<template>
  <data-table-scroll-hint>
  <v-data-table
      :show-select="checkable"
      item-key="id"
      selectable-key="editable"
      class="decreased-fontsize-table rights-table"
      v-model="checked"
      @input="$emit('update:checkedItems', $event)"
      @update:options="clearChecked"
      :page.sync="currentPage"
      :items="itemsList"
      :loading="items === null || portionLoading"
      :headers="headers"
      v-sortable-table="{onEnd:sortTheHeadersAndUpdateTheKey}"
      :key="anIncreasingNumber"
      :items-per-page.sync="itemsPerPage"
      :footer-props="footerProps"
      :item-class="(item) => (item ? 'non-empty' : 'empty')"
  >

    <template v-slot:item.revoke="{item}">
      <v-tooltip v-if="String(item.revoke) === 'true'" top>
        <template v-slot:activator="{on}">
          <v-icon v-on="on">mdi-undo</v-icon>
        </template>
        Revoke
      </v-tooltip>
    </template>

    <template v-slot:item.hasError="{item}">
      <v-tooltip v-if="item.hasError" right>
        <template v-slot:activator="{on, attrs}">
          <span @mousemove="loadErrors(item)">
            <v-icon v-on="on" v-bind="attrs" color="red">mdi-alert</v-icon>
          </span>
        </template>
        <div v-if="errors[String(item.id)]">
          <div v-for="err in errors[String(item.id)]" :key="err.en">
            {{err[$i18n.locale]}}
          </div>
        </div>
        <v-progress-circular color="primary" indeterminate v-else/>
      </v-tooltip>

      <v-icon v-else color="success">mdi-check</v-icon>
    </template>

    <template v-slot:item.actions="{item}">
      <slot name="actions" :row="item"></slot>
    </template>

    <template v-slot:item.claimEndDate="{item}">
      <span v-if="item && ((item.claimEndDate && item.claimEndDate==='1900-01-01') || String(item.revoke) === 'true')">-</span>
      <span v-else-if="item && item.claimEndDate">{{item.claimEndDate}}</span>
      <span v-else>-</span>
    </template>

    <template v-slot:item.dcinfo="{item}">
      <span v-html="item.dcinfo"></span>
    </template>

    <template v-slot:item.claimStartDate="{item}">
      <span v-if="item && ((item.claimStartDate && item.claimStartDate==='1900-01-01') || String(item.revoke) === 'true')">-</span>
      <span v-else-if="item && item.claimStartDate">{{item.claimStartDate}}</span>
      <span v-else>-</span>
    </template>

    <template v-slot:item.internationalCollection="{item}">
      <span v-if="item.internationalCollection">
        <v-icon>mdi-toggle-switch</v-icon>
      </span>
      <span v-else> 
        <v-icon>mdi-toggle-switch-off-outline</v-icon>
      </span>
    </template>

    <template v-slot:item.type="{item}">
      <v-tooltip top v-if="item">
        <template v-slot:activator="{on, attrs}">
          <span v-on="on" v-bind="attrs">
            <v-icon v-if="String(item.type) === '1'" >mdi-volume-high</v-icon>
            <v-icon v-else-if="String(item.type) === '2'" >mdi-video</v-icon>
          </span>
        </template>
        <span v-if="String(item.type) === '1'">{{ $t('rights.types.audio') }}</span>
        <span v-if="String(item.type) === '2'">{{ $t('rights.types.video') }}</span>
      </v-tooltip>
    </template>

    <template v-slot:item.ityp="{item}">
      <v-tooltip top v-if="item">
        <template v-slot:activator="{on, attrs}">
          <span v-on="on" v-bind="attrs">
            <v-icon v-if="String(item.ityp) === '1'">mdi-volume-high</v-icon>
            <v-icon v-else-if="String(item.ityp) === '2'">mdi-video</v-icon>
          </span>
        </template>
        <span v-if="String(item.ityp) === '1'">{{ $t('rights.types.audio') }}</span>
        <span v-if="String(item.ityp) === '2'">{{ $t('rights.types.video') }}</span>
      </v-tooltip>
    </template>

    <template v-slot:item.status="{item}">
      <v-tooltip top v-if="item.status == 'DC'">
        <template v-slot:activator="{on, attrs}">
          <span v-on="on" v-bind="attrs">
            {{ item.status }}
          </span>
        </template>
        <p v-if="item.dcinfo" class="mb-0" v-html="item.dcinfo"></p>
      </v-tooltip>
      <span v-else>
        {{ item.status }}
      </span>
    </template>

  </v-data-table>
  </data-table-scroll-hint>
</template>

<script>

import Sortable from 'sortablejs';
import watchClass from '@/utils/watchClass';
import DataTableScrollHint from '@/components/common/DataTableScrollHint.vue';

export default {
  name: "RightsTable",
  components: { DataTableScrollHint },
  props: {
    items: Array,
    displayedColumns: Array,
    checkedItems: Array,
    continuosAmount: Boolean,
    checkable: {
      type: Boolean,
      default: true
    },
    portionLoading: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    totalCount: {
      type: [Number, Object],
      default: () => null,
    },
    columnSortOrderStore: {
      type: String,
      default: 'noname'
    }
  },
  data() {
    return {
      checked: [],
      itemsPerPage: 100,
      currentPage: 1,
      anIncreasingNumber: 1,
      columnSortOrder: [],
    }
  },
  watch: {
    checkedItems(v) {
      this.checked = v;
    },
    currentPage() {
      if (this.currentPage === (this.lastPage + 1)) {
        if (this.continuosAmount && this.lastPage > 0) {
          this.$emit('load-more');
        }
      }
    },
    displayedColumns() {
      this.columnSortOrder = JSON.parse(JSON.stringify(this.displayedColumns))
    },
    columnSortOrder() {
      this.saveSortorderToLocalStorage();
    }
  },
  mounted() {
    this.loadSortorderFromLocalStorage();
    if (this.columnSortOrder.length === 0) {
      this.columnSortOrder = JSON.parse(JSON.stringify(this.displayedColumns))
    }
  },
  methods: {
    loadErrors(item) {
      this.$emit('load-errors', item)
    },
    clearChecked() {
      this.checked = []
    },
    sortTheHeadersAndUpdateTheKey(evt) {
      console.log(evt.oldIndex, '->',evt.newIndex)
      const headersTmp = this.headers;
      const oldIndex = evt.oldIndex -1;
      const newIndex = evt.newIndex -1;
      const movedItem = headersTmp.splice(oldIndex, 1)[0];
      headersTmp.splice(newIndex, 0, movedItem);
      this.columnSortOrder = headersTmp.map(h => {return h.value ? h.value : null});
      this.anIncreasingNumber += 1;
    },
    saveSortorderToLocalStorage() {
      if (this.$auth.user.name) {
        const key = `${this.columnSortOrderStore}-${this.$auth.user.name}`
        localStorage.setItem(key, JSON.stringify(this.columnSortOrder));
      }
    },
    loadSortorderFromLocalStorage() {
      if (this.$auth.user.name) {
        const key = `${this.columnSortOrderStore}-${this.$auth.user.name}`
        this.columnSortOrder = JSON.parse(localStorage.getItem(key)) || [];
      }
    }
  },
  computed: {
    footerProps() {
      return {
        itemsPerPageOptions: this.$vuetify.breakpoint.mobile ? [] : [50, 100, 200, 500, 2000, 5000],
        pageText: this.totalCount ? `{0}-{1} / ${this.totalCount}` : (this.continuosAmount ? `{0}-{1} / ${this.itemsList.length - 1}+` : '$vuetify.dataFooter.pageText'),
      }
    },
    itemsList() {
      return this.items || [];
    },
    lastPage() {
      return Math.ceil((this.items.length - Number(this.continuosAmount)) / this.itemsPerPage);
    },
    headers() {
      const unsortable = ['actions'];
      const getCol = (value) => ({
        value,
        text: this.$t(`rights.columns.${value}`),
        sortable: !unsortable.includes(value)
      });
      return this.displayedColumns.toSorted(
        (a, b) => this.columnSortOrder.indexOf(a) - this.columnSortOrder.indexOf(b)
      ).map(getCol)
    }
  },
  directives: {
    'sortable-table': {
      inserted: (el, binding) => {
        el.querySelectorAll('th').forEach((draggableEl) => {
          // Need a class watcher because sorting v-data-table rows asc/desc removes the sortHandle class
          watchClass(draggableEl, 'sortHandle');
          draggableEl.classList.add('sortHandle');
        });
        Sortable.create(el.querySelector('tr'), binding.value ? { ...binding.value, handle: '.sortHandle' } : {});
      },
    },
  },
}
</script>

<style>
.rights-table .v-data-table__wrapper tbody tr:not(.non-empty, .v-data-table__empty-wrapper) {
  display: none;
}
</style>